import React from "react";
import { Provider } from "react-redux";
import { ToastContainer } from "react-toastify";
// Internal imports
import "./App.css";
import AppRoutes from "./routes/AppRoutes";
import { store } from "./store";

const App: React.FC = () => {
  return (
    <Provider store={store}>
      <AppRoutes />
      <ToastContainer />
    </Provider>
  );
};

export default App;
